export class FreightModel {
    freightId: number = 0;
    departmentOriginId: number = 0;
    cityOriginId: number = 0;
    departmentDestinyId: number = 0;
    cityDestinyId: number = 0;
    conceptId: number = 0;
    value: number = 0;
    sectorId: number | null = null;
    constructionSiteId: number | null = null;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}
